import * as Sentry from "@sentry/gatsby";

Sentry.init({
	dsn: "https://0ea1883854b0f89a223066c0ceba5d4f@o4509208581898240.ingest.de.sentry.io/4509241410125904",
	// Setting this option to true will send default PII data to Sentry.
	// For example, automatic IP address collection on events
	sendDefaultPii: false,
	environment: process.env.GATSBY_ENVIRONMENT,
});
